import React from 'react';
import Section from './Section';

const About = () => (
  <Section
    id="about"
    bgClass="bg-blue-50"
    title="Sobre a AEAGO"
  >
    <p className="max-w-3xl mx-auto mb-10 text-base leading-[1.6] text-center text-gray-700">
      Fundada em 5 de fevereiro de 1965, a Associação dos Engenheiros Agrônomos de Goiás (AEAGO) é uma entidade de direito privado, sem fins econômicos, políticos ou religiosos.
      Atua para unir, representar e promover o desenvolvimento técnico, científico e profissional dos engenheiros agrônomos, além de colaborar com o crescimento sustentável do agronegócio em Goiás e no Brasil.
    </p>

    <div className="max-w-6xl mx-auto">
      {/* Grid de 6 colunas no desktop para permitir a centralização de 2 itens na linha de baixo */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-5 sm:gap-6">

        {/* Card 1 */}
        <div className="bg-white rounded-xl p-6 flex flex-col items-center text-center shadow lg:col-span-2">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 mb-4 text-[#1a2e5a]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87M12 12a4 4 0 110-8 4 4 0 010 8z" />
          </svg>
          <h3 className="font-semibold text-lg text-[#1a2e5a] mb-1">Comunidade</h3>
          <p className="text-sm text-gray-600">Mais de 15.000 profissionais da agronomia</p>
        </div>

        {/* Card 2 */}
        <div className="bg-white rounded-xl p-6 flex flex-col items-center text-center shadow lg:col-span-2">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 mb-4 text-[#1a2e5a]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
          <h3 className="font-semibold text-lg text-[#1a2e5a] mb-1">Tradição</h3>
          <p className="text-sm text-gray-600">Desde 1965</p>
        </div>

        {/* Card 3 */}
        <div className="bg-white rounded-xl p-6 flex flex-col items-center text-center shadow lg:col-span-2">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 mb-4 text-[#1a2e5a]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path d="M12 14l9-5-9-5-9 5 9 5z" />
            <path d="M12 14l6.16-3.422a12.083 12.083 0 01.84 4.35C19 17.343 15.314 20 12 20s-7-2.657-7-5.072c0-1.57.31-3.045.84-4.35L12 14z" />
          </svg>
          <h3 className="font-semibold text-lg text-[#1a2e5a] mb-1">Capacitação</h3>
          <p className="text-sm text-gray-600">Cursos e treinamentos</p>
        </div>

        {/* Card 4 - Centralizado na segunda linha */}
        <div className="bg-white rounded-xl p-6 flex flex-col items-center text-center shadow lg:col-span-2 lg:col-start-2">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 mb-4 text-[#1a2e5a]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <circle cx="12" cy="12" r="10" strokeWidth={2} />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3" />
          </svg>
          <h3 className="font-semibold text-lg text-[#1a2e5a] mb-1">Representação</h3>
          <p className="text-sm text-gray-600">Defesa da classe</p>
        </div>

        {/* Card 5 - Centralizado na segunda linha */}
        <a
          href={process.env.PUBLIC_URL + encodeURI('/documentos/Tabela de Honorários AEAGO Revisada 032026.pdf')}
          target="_blank"
          rel="noopener noreferrer"
          className="relative bg-white rounded-xl p-6 flex flex-col items-center text-center shadow hover:shadow-md transition lg:col-span-2"
        >
          <span className="absolute top-3 right-3 bg-gold text-white text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full">
            Atualizada
          </span>
          <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 mb-4 text-[#1a2e5a]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <rect x="3" y="3" width="18" height="18" rx="2" strokeWidth={2} />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16l3-4 3 2 4-6" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 18h10" />
          </svg>
          <h3 className="font-semibold text-lg text-[#1a2e5a] mb-1">
            Tabela de Honorários
          </h3>
          <p className="text-sm text-gray-600">
            Revisão 2026 - Consulte e baixe o documento
          </p>
        </a>

      </div>
    </div>
  </Section>
);

export default About;
